import * as React from "react";
import { PinInput } from "./pin-input";

const PinInputContext = React.createContext<{
  maxLength: number;
  value: string;
  onChange: (v: string) => void;
  testId?: string;
} | null>(null);

interface InputOTPProps {
  maxLength: number;
  value: string;
  onChange: (v: string) => void;
  children: React.ReactNode;
  "data-testid"?: string;
}

export function InputOTP({ maxLength, value, onChange, children, ...props }: InputOTPProps) {
  return (
    <PinInputContext.Provider
      value={{
        maxLength,
        value,
        onChange,
        testId: props["data-testid"],
      }}
    >
      {children}
    </PinInputContext.Provider>
  );
}

export function InputOTPGroup({ children }: { children: React.ReactNode }) {
  const ctx = React.useContext(PinInputContext);
  if (!ctx) return null;

  // Detect large size from slot className hints (e.g. "w-14" = kiosk large variant)
  const childrenArray = React.Children.toArray(children);
  const isLarge = childrenArray.some(
    (child: any) => child?.props?.className?.includes("w-14")
  );

  return (
    <PinInput
      length={ctx.maxLength}
      value={ctx.value}
      onChange={ctx.onChange}
      size={isLarge ? "lg" : "default"}
      data-testid={ctx.testId}
    />
  );
}

// InputOTPSlot is a no-op — PinInput renders all slots internally
export function InputOTPSlot(_: { index: number; className?: string }) {
  return null;
}

export function InputOTPSeparator() {
  return null;
}
